import { gql } from '@/__generated__';

const NOTIFICATION_CREATED = gql(`#graphql
  subscription NotificationCreated {
    notificationCreated {
      notification {
        id
      }
    }
  }
`);

export default NOTIFICATION_CREATED;
